import { render } from "./CompletedLogs.vue?vue&type=template&id=f4efa49c&scoped=true"
import script from "./CompletedLogs.vue?vue&type=script&lang=js"
export * from "./CompletedLogs.vue?vue&type=script&lang=js"

import "./CompletedLogs.vue?vue&type=style&index=0&id=f4efa49c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\fchristo\\Documents\\adam-aibackend\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4efa49c"]])

export default __exports__